// extracted by mini-css-extract-plugin
export default {"root":"ZFsEXth1NasvRd2mkmjA","placeHolderShimmer":"KZn7jpdeQ3j63vqHGdvX"};